import axios from "../axios/AxiosInstance";

export function needsAtradiusReview(cover) {
  const document = cover?._doc || cover;
  const limit = document?.totalDecision?.decisionAmtInPolicyCurrency;
  const outstanding = cover?.montantNonFacture;
  if (limit === null || limit === undefined || limit === "" || outstanding === null || outstanding === undefined || outstanding === "") return false;
  return Number.isFinite(Number(limit)) && Number.isFinite(Number(outstanding)) && Number(outstanding) > Number(limit);
}

// Une seule requête pour toutes les couvertures (évite la limite de requêtes du serveur).
export async function loadClientCovers(clients) {
  if (!clients.length) return {};
  const { data } = await axios.post("cover/by-clients", { clientIds: clients.map(client => client._id) });
  return data && typeof data === "object" ? data : {};
}

export async function loadAtradiusReviews() {
  const { data } = await axios.get("client/freelance");
  const clients = Array.isArray(data) ? data : [];
  const covers = await loadClientCovers(clients);
  const reviews = clients
    .filter(client => needsAtradiusReview(covers[client._id]))
    .map(client => ({ client, cover: covers[client._id] }));
  return { reviews, failures: 0, clients };
}
